import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { SearchFlagsService } from '@app/search/services';
import { MenuViewModel } from '@app/shared/components/menu/menu.component';
import { TranslateService } from '@ngx-translate/core';
import { SearchSort } from '../search-view';
import { SearchService } from '@app/search/services/search.service';

@Component({
  selector: 'dgx-search-results-header',
  templateUrl: './search-results-header.component.html',
  styleUrls: ['./search-results-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SearchResultsHeaderComponent {
  @Input() public headerText: string;
  @Input() public totalContentResults: number;
  @Input() public pageNum: number = 1;
  @Input() public numResultsPerPage: number = 20;
  @Input() public isLoading: boolean;
  @Input() public hideSort: boolean;
  @Input() public hideCount: boolean;
  @Input() public sortBy: SearchSort;

  @Output() public sortChange = new EventEmitter<SearchSort>();

  public i18n = this.translateService.instant([
    'Core_SortBy',
    'LearningSearch_MostPopular',
    'LearningSearch_MostRecent',
    'LearningSearch_MostRelevant',
    'LearningSearch_Popular',
    'LearningSearch_Recent',
    'LearningSearch_Relevant',
    'LearningSearch_RangeCount',
    'LearningSearch_RangeCountPlus',
  ]);

  constructor(
    private translateService: TranslateService,
    private searchFlagsService: SearchFlagsService,
    private searchService: SearchService
  ) {}

  public get showSearchLayoutRedesign(): boolean {
    return this.searchFlagsService.showSearchLayoutRedesign;
  }

  public get resultsRange() {
    return this.searchService.getSearchResltsRange(
      this.rangeStart,
      this.rangeEnd,
      this.totalContentResults
    );
  }

  public get hasResults(): boolean {
    return this.totalContentResults > 0;
  }

  public get sortButtonText(): string {
    switch (this.sortBy) {
      case 'popular':
        return this.i18n.LearningSearch_MostPopular;
      case 'recent':
        return this.i18n.LearningSearch_MostRecent;
      case 'relevant':
        return this.i18n.LearningSearch_MostRelevant;
    }
  }

  public get showSort(): boolean {
    return this.totalContentResults > 0 && !this.hideSort;
  }

  private get rangeStart(): number {
    return this.limit - this.numResultsPerPage + 1;
  }

  private get rangeEnd(): number {
    return this.limit > this.totalContentResults
      ? this.totalContentResults
      : this.limit;
  }

  private get limit(): number {
    return this.pageNum * this.numResultsPerPage;
  }

  public get menuConfig(): MenuViewModel[] {
    return [
      {
        icon: this.sortBy === 'popular' ? 'checkmark' : undefined,
        title: this.i18n.LearningSearch_MostPopular,
        defaultAction: () => this.doSortChange('popular'),
      },
      {
        icon: this.sortBy === 'recent' ? 'checkmark' : undefined,
        title: this.i18n.LearningSearch_MostRecent,
        defaultAction: () => this.doSortChange('recent'),
      },
      {
        icon: this.sortBy === 'relevant' ? 'checkmark' : undefined,
        title: this.i18n.LearningSearch_MostRelevant,
        defaultAction: () => this.doSortChange('relevant'),
      },
    ];
  }

  private doSortChange(sortType: SearchSort): void {
    this.sortChange.emit(sortType);
  }
}
